module.exports = __webpack_public_path__ + "static/media/sizesshirt.1ed670a1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/sizesshirt.jpg
// module id = 438
// module chunks = 0